import React from "react";
import CollapsibleSection from "../common/CollapsibleSection";
import styles from "../../_css/Home.module.css";
import Pagination from "../UI/Pagination";
import InfoCard from "./InfoCard";
import { useSelector } from "react-redux";
import { DataLoader } from "../common/ResponseLoader";

const PAGE_SIZE = 10;

function Sessions({ 
  onReadMore,
  // State props
  openSections,
  setOpenSections,
  sectionPage,
  setSectionPage,
  sections,
  sectionsData,
  fetchingSections,
  selectedCategory,
  setSelectedCategory
}) {
  const lang = useSelector((state) => state.language.lang);


  // const totalSectionPages = Math.ceil(SECTIONS.length / PAGE_SIZE);
  // const pagedSections = SECTIONS.slice(
  //   (sectionPage - 1) * PAGE_SIZE,
  //   sectionPage * PAGE_SIZE
  // );
  // const totalSections = SECTIONS.length;
  // const startIdx = (sectionPage - 1) * PAGE_SIZE + 1;
  // const endIdx = Math.min(sectionPage * PAGE_SIZE, totalSections);

  return (
    <div style={{ borderRadius: "12px", width: "100%" }} className="bg-white pt-2 pb-4 mt-3">
      {sections.map((value, index) => {
        const globalIndex = (sectionPage - 1) * PAGE_SIZE + index;
        return (
          <div key={globalIndex} className={styles.tableContainer}>
            <CollapsibleSection
              title={lang === "ar" ? value.name_arabic : value.name}
              headerClassName={styles.collapsibleHeader}
              open={openSections.includes(globalIndex)}
              onHeaderClick={() => {
                setOpenSections(prev => {
                  if (prev.includes(globalIndex)) {
                    // Remove section from open array (close it)
                    return prev.filter(index => index !== globalIndex);
                  } else {
                    // Add section to open array (open it)
               
                    return [...prev, globalIndex];
                  }
                });
                setSelectedCategory(value);
              }}
            >
              {!fetchingSections[value.id] &&
                sectionsData[value.id]?.map((sessionValue, index) => {
                  return (
                    <InfoCard
                      title={lang === "ar" ? sessionValue.title_arabic : sessionValue.title}
                      description={
                        lang === "ar"
                          ? sessionValue.description_arabic
                          : sessionValue.description
                      }
                      image={sessionValue.image_url}
                      key={index}
                      onReadMore={() => {
                        onReadMore();
                        sessionStorage.setItem(
                          "sessionData",
                          JSON.stringify(sessionValue)
                        );
                      }}
                      onStart={() => {
                        sessionStorage.setItem(
                          "sessionData",
                          JSON.stringify(sessionValue)
                        );

                        sessionStorage.removeItem("resumeSessionData");
                        sessionStorage.removeItem("chatHistory");
                      }}
                      onPlay={() => {
                        sessionStorage.setItem(
                          "sessionData",
                          JSON.stringify(sessionValue)
                        );
                        sessionStorage.removeItem("resumeSessionData");
                        sessionStorage.removeItem("chatHistory");
                      }}
                    />
                  );
                })}
              {fetchingSections[value.id] && <DataLoader />}
            </CollapsibleSection>
          </div>
        );
      })}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 16,
        }}
      >
        <div className={styles.tableFooter}>
          Showing {startIdx}–{endIdx} of {totalSections} Sections
        </div>
        <Pagination
          currentPage={sectionPage}
          totalPages={totalSectionPages}
          onPageChange={setSectionPage}
          padding="0 24px"
          marginTop={0}
        />
      </div> */}
    </div>
  );
}

export default Sessions;
